module.exports = __webpack_public_path__ + "static/media/couldyoubemine.5366506d.jpg";